const findParentElement = require('../dom/find-parent-element');

function getAttributes(element) {
  const ref = element.getAttribute('flow-ref');
  const attributes = {
    id: element.getAttribute('flow-variant') || element.getAttribute('flow-order'),
    orderLine: element.getAttribute('flow-order-line'),
    selector: element.getAttribute('flow-selector'),
    default: element.getAttribute('flow-default'),
    prefix: element.getAttribute('data-flow-item-prefix'),
    suffix: element.getAttribute('data-flow-item-suffix'),
    ref,
    each: element.getAttribute('flow-each'),
    parentIdElement: ref && findParentElement(element, (elem) => {
      const id = elem.getAttribute('flow-id');
      return id && id === ref;
    }),
  };

  return attributes;
}

module.exports = getAttributes;



// WEBPACK FOOTER //
// ./static/js/v0/utilities/tags/get-attributes.js